import SEOHead from '@/components/base/SEOHead';
import SchemaOrg from '@/components/base/SchemaOrg';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import CategoryNav from './components/CategoryNav';
import FeaturedArticles from './components/FeaturedArticles';
import LatestArticles from './components/LatestArticles';
import FAQSection from './components/FAQSection';
import CTASection from './components/CTASection';

export default function Home() {
  const canonicalUrl = typeof window !== 'undefined' ? window.location.origin + (window as any).__BASE_PATH__ + '/' : '/';

  const orgSchema = {
    name: '麻将竞技资讯',
    url: canonicalUrl,
    description: '麻将竞技资讯平台，提供麻将技巧、爆奖案例、牌型分析等专业内容',
  };

  const webSiteSchema = {
    name: '麻将竞技资讯',
    url: canonicalUrl,
    description: '麻将竞技资讯平台，提供麻将技巧、爆奖案例、牌型分析等专业内容',
    inLanguage: 'zh-CN',
  };

  const webPageSchema = {
    name: '麻将竞技资讯 - 首页',
    url: canonicalUrl,
    description: '麻将糊了中17万！真实爆奖案例与技巧全揭秘。深度解析麻将爆奖瞬间背后的规则、牌型组合与高倍奖励机制。',
    inLanguage: 'zh-CN',
  };

  return (
    <>
      <SEOHead
        title="麻将糊了中17万！真实爆奖案例与技巧全揭秘 - 麻将竞技资讯"
        description="麻将糊了中17万的真实案例引发热议！深度解析麻将爆奖瞬间背后的规则、牌型组合与高倍奖励机制，带你了解如何在合法娱乐平台上体验麻将竞技的极致乐趣。"
        keywords="麻将糊了中17万,麻将爆奖,麻将中大奖,麻将牌型技巧,麻将高倍奖励,线上麻将,麻将竞技娱乐"
        canonicalUrl={canonicalUrl}
        ogImage="https://readdy.ai/api/search-image?query=Rich%20dark%20mahogany%20wood%20surface%20with%20scattered%20mahjong%20tiles%20in%20warm%20golden%20and%20red%20tones%2C%20dramatic%20chiaroscuro%20lighting%2C%20luxurious%20Chinese%20aesthetic&width=1200&height=630&seq=mahjong-og-home&orientation=landscape"
      />
      <SchemaOrg type="Organization" data={orgSchema} />
      <SchemaOrg type="WebSite" data={webSiteSchema} />
      <SchemaOrg type="WebPage" data={webPageSchema} />

      <Navbar />
      <main>
        <HeroSection />
        <CategoryNav />
        <FeaturedArticles />
        <LatestArticles />
        <FAQSection />
        <CTASection />
      </main>
      <Footer />
    </>
  );
}